/**
 * @typedef {import('../../../../fbs-api-types.d.ts').StateZoneInfoMap} StateZoneInfoMap
 */

/**
 * Calculates the minimum zone for each state across a set of warehouses.
 * This is used to determine the best shipping zone coverage when combining multiple warehouses.
 * @param {string[]} warehouseIds - Array of warehouse IDs to include in the calculation
 * @param {StateZoneInfoMap | null} stateZoneInfo - Map of state codes to warehouse zone data
 * @returns {Map<string, number>} Map of state code to minimum zone across the selected warehouses
 */
export const calculateStateZoneMap = (warehouseIds, stateZoneInfo) => {
  const stateZoneMap = new Map();

  if (!stateZoneInfo || warehouseIds.length === 0) {
    return stateZoneMap;
  }

  // For each state, find the minimum zone across selected warehouses
  Object.entries(stateZoneInfo).forEach(([stateCode, warehouseZoneMap]) => {
    warehouseIds.forEach((warehouseId) => {
      const zoneForWarehouse = warehouseZoneMap[warehouseId];
      if (zoneForWarehouse !== null && zoneForWarehouse !== undefined) {
        const currentMinZone = stateZoneMap.get(stateCode);
        if (currentMinZone === undefined || zoneForWarehouse < currentMinZone) {
          stateZoneMap.set(stateCode, zoneForWarehouse);
        }
      }
    });
  });

  return stateZoneMap;
};
